import { Field, Textarea } from "@chakra-ui/react";
import React from "react";

interface Props {
  invalid?: boolean;
  required?: boolean;
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  rows?: number;
  maxLength?: number;
  helperText?: string;
  placeholder?: string;
}

function TextAreaInput({
  invalid,
  required,
  label,
  name,
  value,
  onChange,
  error,
  rows = 4,
  maxLength,
  helperText,
  placeholder,
}: Props) {
  return (
    <Field.Root invalid={invalid} required={required}>
      <Field.Label>
        {label} <Field.RequiredIndicator />
      </Field.Label>
      <Textarea
        name={name}
        value={value}
        onChange={onChange}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
      />
      <Field.HelperText>{helperText}</Field.HelperText>
      <Field.ErrorText>{error}</Field.ErrorText>
    </Field.Root>
  );
}

export default TextAreaInput;
